import React from 'react';
import { Box, Typography } from '@mui/material';

const HistoryHeader = () => {
  return (
    <Box>
        <Typography variant='h3' sx={{color:'rgba(86, 4, 246, 1)', my:2, fontSize:{xs:'1.5rem', md:'3rem'}}}>
            📦 Your Order history
        </Typography>
        <Typography sx={{fontSize:'.8rem', my:2, color:'rgba(18, 18, 18, 0.8)'}}>
            Track your purchases and enjoy fast delivery across Nigeria. Mydarads is here for you.
        </Typography>
    </Box>
  )
}

export default HistoryHeader